import palette     from './variables.palette.css.mjs';
import typography  from './variables.typography.css.mjs';
import shadows     from './variables.shadows.css.mjs';
import borders     from './variables.borders.css.mjs';
import spacing     from './variables.spacing.css.mjs';
import sizes       from './variables.sizes.css.mjs';
import viewports   from './variables.viewports.css.mjs';
import states      from './variables.states.css.mjs';
import transitions from './variables.transitions.css.mjs';
import components  from './variables.components.css.mjs';
import zindex      from './variables.zindex.css.mjs';
import surface     from './variables.surface.css.mjs';
import dark        from './variables.dark.css.mjs';
import {scrollbarStyles} from './scrollbars.css.mjs';

import { css } from 'lit';

export default css`
  :root {
    ${palette}
    ${typography}
    ${shadows}
    ${borders}
    ${spacing}
    ${sizes}
    ${viewports}
    ${states}
    ${transitions}
    ${components}
    ${zindex}
    ${surface}
    ${scrollbarStyles}
  }

  /* Dark theme — explicit opt-in only, via the theme switcher's mode attribute.
     OS preference (prefers-color-scheme) intentionally does NOT trigger dark;
     apps default to light unless they set [data-theme-mode="dark"]. */
  [data-theme-mode="dark"] { ${dark} }
  :root[data-theme-mode="dark"] { ${dark} }
`;
